import React, {useEffect, useState} from "react";
import ReactSeamlessScroll from "react-seamless-scroll";
import "../style/date.css";

const TablePlay = (props) => {
  const { subData } = props;
  return (
    <tr>
      <td className="rank">
        <p>
          <span>{subData.rank}</span>
        </p>
      </td>
      <td>{subData.company}</td>
      <td>{subData.avgScore}</td>
    </tr>
  );
};

const Broadcast2 = React.memo((props) => {
  const { playData } = props;
  const fun = (playData) => {
    if(!playData) return
    if(playData && playData.length > 5 && playData.length < 10){
      playData.push(...playData.slice(3))
      playData.push(...playData.slice(3))
    }
    return playData
  }

let [data, setData] = useState([])
  useEffect(()=>{
    if (!playData) return
    setData(fun(playData))
})
  return (
    <ReactSeamlessScroll>
      <table className="table-play">
        <tbody>
          {
            data && data.slice(3).map((item) => (
              <TablePlay subData={item} key={data.length+Math.random()} />
            ))
          }
        </tbody>
      </table>
    </ReactSeamlessScroll>
  );
});

export default Broadcast2;